import React, {useEffect, useState} from 'react';
import {Link, useNavigate, useOutletContext} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import CardGrid from "../../../components/Card/CardGrid";
import CardSimple from "../../../components/Card/CardSimple";
import AdminCard from "../../../components/Card/AdminCard";
import stylesCard from "../../../components/Card/AdminCard.module.css";
import SearchGlobal from "../../../components/Search/SearchGlobal";
import Planning from "../../../components/Planning/Planning";
import {parseSeancesPlanning, parseSeancesPlanningAdmin} from "../../../services/PlanningService";
import TitleSecondary from "../../../components/Title/TitleSecondary";
import MyDonut from "../../../components/Charts/MyDonut";
import SeanceList from "../../../components/Admin/Seances/SeanceList";
import styles from "../Admin.module.css";
import DateService from "../../../services/DateService";
import Routing from "../../../services/routing";
import BlocCrmDisable from "../../../components/Bloc/BlocCrmDisable";

function AdminDashboardPage() {
    const { user } = useUser();
    const { showModal, hideModal } = useModal();
    const [myApiData, setMyApiData] = useState([]);
    const [mySeances, setMySeances] = useState([]);
    const now = DateService.formatFrenchDateWithoutTime();
    const threeMonthsAgo = DateService.subtractMonths(3);
    const statActiviteTypeUrl = `/stats/activite_types?filter_date=${threeMonthsAgo}%2C${now}`;
    const navigate = useNavigate();

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const chargerDonnees = async (start, end) => {
        try {
            const response = await AxiosConfig.get('/admin/seances?start=' + start + '&end=' + end);
            setMySeances(response.data.mySeances);
        } catch (error) {
            console.error('error', error);
        }
    };

    const onSearchSubmit = async (values) => {}

    function renderPlanning() {
        if (!mySeances) return null;

        const myPlanningDataParse = parseSeancesPlanningAdmin(mySeances);

        const planningEventClick = (clickInfo) => {
            clickInfo.jsEvent.preventDefault();
            const eventDate = new Date(clickInfo.event.start);
            const link = clickInfo.event.extendedProps.link;

            const eventsCount = myPlanningDataParse.events.filter(event => DateService.sameDay(event.startDate, eventDate)).length

            if (eventsCount > 1) {
                // Make date with eventDate format YYYY-MM-DD and add new variable with the next day after the eventDate. Then apply filter between the two dates
                const prevDay = DateService.formatDateWithoutTime(eventDate);
                const nextDay = new Date(eventDate);
                nextDay.setDate(nextDay.getDate() + 1);
                // const nextDayFormatted = DateService.formatDateWithoutTime(nextDay);
                navigate(`/admin/seances?page=1&filter_debut=${prevDay}&filter_fin=${prevDay}`);
                // navigate(`/seances/date/${DateService.formatDateWithoutTime(eventDate)}`);
            } else if (link) {
                // Go to /admin/seances/:id
                const seanceId = clickInfo.event.id;
                navigate(`/admin/seances/${seanceId}`);
                // window.location.href = link;
            } else {
                handleError("Oups ! on dirait qu'il y a une erreur :) ");
            }
        };

        return (
            <div className={styles.duoPlanningListContainer}>
                <TitleSecondary text={"Planning des cours"}/>
                <Planning events={myPlanningDataParse.events} height={"250px"} legend={myPlanningDataParse.legend} onDatesChange={chargerDonnees} handleEventClick={planningEventClick}/>
                <SeanceList seances={mySeances} title={"Séances du mois"}/>
            </div>
        );
    }

    return (
        <div className="content">
            <TitleMain text="Tableau de bord"/>

            {user.roles.includes("ROLE_SUPER_ADMIN") &&
                <BlocCrmDisable />
            }

            <div style={{margin: "20px 0 40px 0"}}>
                <SearchGlobal onSearch={onSearchSubmit}/>
            </div>

            <div className={stylesCard.adminCardContainer}>
                <AdminCard lien={Routing.routes.adminAbsences} titre="Absences"/>
                <AdminCard lien={Routing.generate({ route: Routing.routes.adminUtilisateurs, queryParams: {role: "ROLE_COACH"}})} titre="Coachs"/>
                <AdminCard lien={Routing.routes.adminCrm} titre="CRM"/>
                <AdminCard lien={Routing.routes.adminEntreprises} titre="Entreprises"/>
                {user.roles.includes("ROLE_SUPER_ADMIN") &&
                <AdminCard lien={Routing.routes.adminRoles} titre="Roles"/>
                }
                {/* <AdminCard lien="/admin/seances" titre="Séances"/> */}
                <AdminCard lien={statActiviteTypeUrl ?? Routing.routes.statsActiviteTypes} titre="Stats activités"/>
                <AdminCard lien={Routing.routes.statsUsers} titre="Stats utilisateurs"/>
                <AdminCard lien={Routing.routes.adminJustificatifsTypes} titre="Types de justificatif"/>
                <AdminCard lien={Routing.routes.adminActiviteTypes} titre="Types d'activités"/>
                <AdminCard lien={Routing.routes.adminUtilisateurs} titre="Utilisateurs"/>
            </div>

            {renderPlanning()}

        </div>
    )
}

export default AdminDashboardPage;
